/* eslint-disable react/prop-types */
import React, { createContext, useState } from 'react';

export const ModalContext = createContext();

export const initialState = {
  modalType: null,
  modalProps: {},
};

function lockBody() {
  document.body.style.overflow = 'visible';
  const next = document.getElementById('__next');
  next.style.overflow = 'hidden';
}

function unlockBody() {
  const next = document.getElementById('__next');
  next.style.overflow = 'initial';
}
export default function ModalProvider({ children }) {
  const [modalState, setModalState] = useState(initialState);

  function showModal({ modalType, modalProps }) {
    lockBody();
    setModalState({
      modalType,
      modalProps,
    });
  }

  function hideModal() {
    unlockBody();
    setModalState(initialState);
  }

  const contextProps = {
    modalType: modalState.modalType,
    modalProps: modalState.modalProps,
    showModal,
    hideModal,
  };

  return <ModalContext.Provider value={contextProps}>{children}</ModalContext.Provider>;
}
